import {cn} from '@/modules/foundation/shared/tailwind';

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={cn('animate-pulse bg-gray-200 rounded-sm', className)} {...props} />;
}

export {Skeleton};
